let lastValue = '';

export default (postal, number) => {
  // Both fields should've a value
  if (postal === '' || number === '') {
    return false;
  }

  // Postal code should be at least 6 characters
  if (postal.length < 4) {
    return false;
  }

  const mergedValue = postal + number;

  // Check if we didn't enter the same information as the last request
  if (lastValue === mergedValue) {
    return false;
  }

  lastValue = mergedValue;

  return true;
};
